(function () {
  'use strict';
  var root = document.querySelector('[data-email-lab]');
  if (!root) return;
  var $ = function (s) {
    return root.querySelector(s);
  };
  var $$ = function (s) {
    return Array.from(root.querySelectorAll(s));
  };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  // The server takes up to 60,000 bytes of email text or code.
  var MAX_BYTES = 60000;
  var inputKind = 'text',
    inputFormat = 'text',
    imageData = '',
    activeReport = null,
    lastInput = null,
    activeSample = false,
    activeRole = 'original',
    orderedFindings = [],
    safeBody = null;
  // A real review and, once asked for, the review of its suggested new
  // version. Both stay on the page so the visitor can compare them; the new
  // review used to replace the first one.
  var reviews = [];
  var request = null,
    loadingTimer = null,
    requestVersion = 0,
    pendingMode = 'form';
  var labels = {
    clarity: 'Clear words',
    cta: 'Button or link',
    relevance: 'Fit for the reader',
    trust: 'Trust',
    // "Easy to read" sat beside "Clear words" but meant the visual design.
    design: 'Look and layout'
  };
  // Words for the rubric's bands (18–20, 15–17, 10–14, 5–9, 0–4), one set per
  // part. The same generic "Works well" on every part said nothing about it.
  var bandWords = {
    overall: ['Works very well', 'Works well with a few changes', 'Room to improve', 'Needs work', 'Needs major fixes'],
    clarity: ['Very clear', 'Clear, with small fixes', 'Some parts are unclear', 'Hard to follow', 'Very hard to follow'],
    cta: ['Clear next step', 'Clear, could be sharper', 'The next step is vague', 'The next step is hard to find', 'No clear next step'],
    relevance: ['Fits the reader well', 'Fits, with small changes', 'Only partly fits', 'A poor fit', 'Wrong for this reader'],
    trust: ['Clear and believable', 'Believable, with a detail to check', 'Some claims need checking', 'Several claims need backing up', 'Claims with no support'],
    design: ['Easy to scan', 'Easy to scan, with small fixes', 'Some parts are hard to see', 'Hard to read', 'Very hard to read']
  };
  function band(score, id) {
    var words = bandWords[id] || bandWords.overall;
    return words[score >= 18 ? 0 : score >= 15 ? 1 : score >= 10 ? 2 : score >= 5 ? 3 : 4];
  }
  // Mirrors the server (review.go Validate): the average of the scored parts
  // times five. Unscored parts are skipped, never counted as zero.
  function rubricScore(categories) {
    var scored = categories.filter(function (c) {
      return c.score !== null;
    });
    if (!scored.length) return 0;
    return Math.round(
      (scored.reduce(function (sum, c) {
        return sum + c.score;
      }, 0) * 5) / scored.length
    );
  }
  // Plain words, one colour each. The chess marks ("!!", "!?") meant nothing
  // for email, and "!" read as a rating when it meant "check this claim".
  var grades = {
    brilliant: ['keep', 'Keep'],
    strong: ['keep', 'Keep'],
    missed: ['improve', 'Improve'],
    risky: ['check', 'Check']
  };
  var priority = { risky: 0, missed: 1, strong: 2, brilliant: 2 };
  // The same names as the choices on the form. The result used to echo
  // "Help someone finish buying" for "Cart reminder".
  var goals = {
    cart: 'Cart reminder',
    welcome: 'Welcome',
    winback: 'Win-back',
    launch: 'New product',
    campaign: 'Offer or sale'
  };
  var goalInputs = $$('input[name="goal"]');
  function selectedGoal() {
    var selected = goalInputs.find(function (input) { return input.checked; });
    return selected ? selected.value : '';
  }
  function setGoalInvalid(invalid) {
    var group = $('#email-goal');
    if (invalid) group.setAttribute('aria-invalid', 'true');
    else group.removeAttribute('aria-invalid');
    goalInputs.forEach(function (input) {
      if (invalid) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    });
    $('#lab-goal-error').hidden = !invalid;
  }
  function focusGoal() {
    // Keep the native radio group's tab and arrow-key behavior intact.
    goalInputs[0].focus({ preventScroll: true });
    $('#email-goal').scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'center' });
  }

  // The example is a faithful run of ONE real path: a review of pasted HTML.
  // It renders in the same sandboxed preview, highlights only exact matches
  // and leaves Look and layout unscored, as the server does for text and HTML.
  // The old example mixed a designed email, a layout score, in-email
  // highlights and outlines that no real review can produce.
  var sampleHtml = [
    '<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#faf8f1">',
    '<tr><td style="padding:22px 24px 6px;text-align:center;color:#334c35;font-size:12px;font-weight:bold">SOLARA</td></tr>',
    '<tr><td style="padding:10px 24px;text-align:center"><h1 style="margin:0;color:#35492e;font-size:28px;font-weight:normal">Still thinking it over?</h1></td></tr>',
    '<tr><td style="padding:12px 24px;text-align:center"><img src="https://solara.example/images/daily-cleanser.jpg" width="360" alt="Solara Daily Cleanser"></td></tr>',
    '<tr><td style="padding:8px 24px;text-align:center;color:#52634a;font-size:15px;line-height:1.6">Your Daily Cleanser is waiting.<br>Take another look whenever you’re ready.</td></tr>',
    '<tr><td style="padding:18px 24px;text-align:center"><a href="https://solara.example/" style="background-color:#455939;color:#ffffff;padding:12px 28px;border-radius:3px;font-weight:bold">Shop now →</a></td></tr>',
    '<tr><td style="padding:20px 24px;text-align:center;color:#77816c;font-size:11px">Solara · A sample cart reminder<br><a href="https://solara.example/unsubscribe" style="color:#77816c">Unsubscribe from these emails</a></td></tr>',
    '</table>'
  ].join('\n');
  var sampleInput = {
    kind: 'text',
    format: 'html',
    content: sampleHtml,
    subject: 'You forgot something',
    goal: 'cart',
    audience: 'A first-time shopper who left a cleanser in their cart.'
  };
  // Every lost point has a stated reason, and each one maps to a tip:
  // Clear words (subject), Button or link ("Shop now") and Fit (no price).
  // Trust is full because the email makes no claim that needs backing up.
  var sampleReport = {
    verdict: 'Make the button say where it goes.',
    summary:
      'The email names the cleanser and keeps a calm tone. Make the button and the inbox title say this is about their cart.',
    categories: [
      {
        id: 'clarity',
        score: 16,
        reason:
          'The sentences are short and plain. The inbox title says “something” instead of naming the Daily Cleanser.'
      },
      {
        id: 'cta',
        score: 11,
        reason:
          'There is one button, but “Shop now” does not say it goes back to the cart, so the next step is vague.'
      },
      {
        id: 'relevance',
        score: 16,
        reason:
          'It names the cleanser this shopper left, which fits a cart reminder. It leaves out the price, which a first-time shopper may want to see again.'
      },
      {
        id: 'trust',
        score: 20,
        reason:
          'There is no sale, deadline or low-stock claim to check. Everything it says fits a reminder about a cart.'
      },
      {
        id: 'design',
        score: null,
        reason:
          'We need a screenshot to score how your email looks. HTML code or plain text is not enough.'
      }
    ],
    findings: [
      {
        grade: 'missed',
        title: 'Say where the button goes.',
        evidence: '“Shop now →”',
        explanation:
          '“Shop now” could mean any page in the store. This email is about one cart, so the button should say it goes back there.',
        fix: 'Change it to “Back to your cart” and link it to the shopper’s saved cart.'
      },
      {
        grade: 'missed',
        title: 'Name the cleanser in the inbox title.',
        evidence: 'Subject: “You forgot something”',
        explanation:
          'The title in the inbox says “something”, so the shopper can’t tell what the email is about before opening it.',
        fix: 'Try “Your Daily Cleanser is still in your cart”.'
      },
      {
        grade: 'missed',
        title: 'Show the price.',
        evidence: '“Your Daily Cleanser”',
        explanation:
          'The email names the cleanser but not what it costs. Seeing the price again reminds the shopper what they chose without opening the store.',
        fix: 'Add the price beside the name, like “Daily Cleanser · [price]”.'
      },
      {
        grade: 'strong',
        title: 'The email names the product.',
        evidence: '“Your Daily Cleanser is waiting.”',
        explanation:
          'The shopper can see which item they left, so they know why they got this email.',
        fix: 'Keep the product name in the email and add it to the inbox title.'
      },
      {
        grade: 'strong',
        title: 'The calm tone suits a first-time shopper.',
        evidence: '“Take another look whenever you’re ready.”',
        explanation:
          'This line reminds without pushing. It fits someone who is still making up their mind.',
        fix: 'Keep this line.'
      }
    ],
    rewrite: {
      subject: 'Your Daily Cleanser is still in your cart',
      preview: 'Pick up where you left off, whenever you’re ready.',
      headline: 'Still thinking it over?',
      body: [
        'Your Daily Cleanser ([price]) is still in your cart.',
        'Take another look whenever you’re ready.'
      ],
      cta: 'Back to your cart',
      rationale:
        'The inbox title and the button now say this is about the shopper’s cart. Add the real price, and link the button to their saved cart before sending.'
    },
    // The server's own wording for a text or HTML review, unchanged.
    limitations: [
      'This score rates the email using your goal and the readers you described. It does not predict clicks or sales.',
      'We did not check if links work, if mail reaches an inbox, proof of who sent it, permission to email each person, or whether the email follows the law.',
      'The new version may need fixes. Check the product facts, offers, links and who can receive it before sending.',
      'We read your email code or text without loading outside images or opening links. We did not score how it looks or test it in email apps.'
    ]
  };
  sampleReport.score = rubricScore(sampleReport.categories);

  function track(name, values) {
    // Only fixed action names and enumerated categories. Never content, filenames,
    // grades, email addresses or campaign context in analytics.
    document.dispatchEvent(
      new CustomEvent('myuser:tool-event', {
        detail: { name: name, values: values || {} }
      })
    );
  }
  function text(node, value) {
    node.textContent = value == null ? '' : String(value);
  }
  function el(tag, className, value) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (value !== undefined) text(n, value);
    return n;
  }
  function bytes(value) {
    return new Blob([value]).size;
  }
  function kb(n) {
    return n < 1000 ? 'under 1 KB' : Math.round(n / 1000) + ' KB';
  }
  // Round up past the limit: 60,003 bytes must not read as "60 KB of 60 KB".
  function overKb(n) {
    return Math.ceil(n / 1000) + ' KB';
  }
  function sentNote(compact) {
    return (compact.before >= 1000 ? 'we sent ' + kb(compact.after) + ' of your ' + kb(compact.before) + ' after removing ' : 'we removed ') + listText(compact.removed);
  }
  function listText(items) {
    return items.length < 2 ? items.join('') : items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
  }
  function focusSection(node, scroll) {
    node.tabIndex = -1;
    node.focus({ preventScroll: true });
    if (scroll === false) return;
    node.scrollIntoView({
      behavior: reduced.matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }
  // Form controls keep their place in the tab order; focusSection's
  // tabIndex = -1 used to drop the email box from it.
  function focusControl(node, scrollTarget) {
    node.focus({ preventScroll: true });
    (scrollTarget || node).scrollIntoView({
      behavior: reduced.matches ? 'auto' : 'smooth',
      block: 'center'
    });
  }
  function watchingReview() {
    var waiting = $('[data-review-loading]');
    var bounds = waiting.getBoundingClientRect();
    var header = document.querySelector('.site-header');
    var visibleTop = Math.max(0, header ? header.getBoundingClientRect().bottom : 0);
    return !document.hidden && !waiting.hidden && waiting.contains(document.activeElement) &&
      bounds.bottom > visibleTop && bounds.top < window.innerHeight;
  }
  function error(message) {
    text($('[data-review-error]'), message);
    $('[data-review-error]').hidden = !message;
    if ($('[data-error-actions]')) $('[data-error-actions]').hidden = !message;
  }
  function rewriteError(message) {
    text($('[data-rewrite-error]'), message);
    $('[data-rewrite-error]').hidden = !message;
  }
  function workflow(step) {
    root.dataset.labState = step;
    $$('[data-lab-stage]').forEach(function (item) {
      if (item.dataset.labStage === step) item.setAttribute('aria-current', 'step');
      else item.removeAttribute('aria-current');
    });
  }
  function clearRequest() {
    requestVersion++;
    if (request) request.abort();
    request = null;
    clearInterval(loadingTimer);
    loadingTimer = null;
  }
  function startLoading() {
    root.dataset.reviewLoading = 'true';
    $('[data-review-loading]').hidden = false;
    $('[data-entry]').hidden = true;
    $('[data-results]').hidden = true;
    workflow('review');
    focusSection($('[data-review-loading]'));
  }
  // A new version is reviewed from the results. When that fails or is
  // cancelled, go back to the results, not to the visitor's own email form.
  function endLoading() {
    var backToResults = pendingMode === 'rewrite' && !!activeReport;
    root.dataset.reviewLoading = 'false';
    $('[data-review-loading]').hidden = true;
    $('[data-entry]').hidden = backToResults;
    $('[data-results]').hidden = !activeReport;
    workflow(backToResults ? 'review' : 'input');
  }

  if ($('[data-fix-input]')) $('[data-fix-input]').addEventListener('click', function () {
    if (inputKind === 'image') focusControl($('#email-image'), $('.lab-dropzone'));
    else focusControl($('#email-content'));
  });

  var formatHelp = {
    text: 'Include the whole email and its button text. Text reviews check the words, not the design.',
    html: 'HTML is the code behind an email. Paste it to review the words. To check how it looks, use a screenshot.',
    image: 'Include the full email, with words large enough to read. Add the subject below if it is not in the picture.'
  };
  $$('[data-input-tab]').forEach(function (button) {
    button.addEventListener('click', function () {
      inputFormat = button.dataset.inputTab;
      inputKind = inputFormat === 'image' ? 'image' : 'text';
      $$('[data-input-tab]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === button));
      });
      $('[data-text-input]').hidden = inputKind !== 'text';
      $('[data-image-input]').hidden = inputKind !== 'image';
      if ($('[data-input-heading]')) text($('[data-input-heading]'), inputFormat === 'image' ? 'Add your email screenshot' : inputFormat === 'html' ? 'Paste your email code' : 'Paste your email');
      text($('[data-content-label]'), inputFormat === 'html' ? 'Email HTML code' : 'Email text');
      $('#email-content').placeholder = inputFormat === 'html'
        ? 'Paste the code behind your email. We will not open its links or load outside images.'
        : 'Paste the words in your email. Include the text on its main button or link.';
      $('#email-content').dataset.format = inputFormat;
      text($('[data-format-help]'), formatHelp[inputFormat]);
      error('');
      updateSizeNote();
    });
  });

  // Pasted HTML used to be cut at 60,000 characters by the text box itself. A
  // real campaign template (171 KB, its <body> starting after 105,000
  // characters) lost its whole body that way, and the AI read only <head> CSS.
  // Send what the review reads: the words, the tags and image descriptions.
  // DOMParser documents are inert: nothing runs and nothing loads.
  var dropTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'LINK', 'META', 'TITLE', 'BASE', 'IFRAME', 'OBJECT', 'EMBED', 'SVG', 'MATH']);
  function compactHtml(source) {
    var doc = new window.DOMParser().parseFromString(source, 'text/html');
    var found = { head: /<head[\s>]/i.test(source), styles: !!doc.head.querySelector('style'), comments: false, settings: false };
    if (!found.head && doc.head.querySelector('meta,title,link,base,script')) found.settings = true;
    (function clean(node) {
      Array.from(node.childNodes).forEach(function (child) {
        if (child.nodeType === 8) {
          found.comments = true;
          child.remove();
          return;
        }
        if (child.nodeType === 3) {
          // Preview-text padding is often hundreds of invisible characters.
          child.nodeValue = child.nodeValue.replace(/[\u200b-\u200d\u2060\ufeff\u034f\u00ad]/g, '').replace(/\s+/g, ' ');
          return;
        }
        if (child.nodeType !== 1) {
          child.remove();
          return;
        }
        var tag = child.nodeName.toUpperCase();
        if (dropTags.has(tag)) {
          if (tag === 'STYLE') found.styles = true;
          else found.settings = true;
          child.remove();
          return;
        }
        Array.from(child.attributes).forEach(function (attribute) {
          if (attribute.name === 'alt' && tag === 'IMG') return;
          if (attribute.name === 'style') found.styles = true;
          else found.settings = true;
          child.removeAttribute(attribute.name);
        });
        clean(child);
      });
    })(doc.body);
    var html = doc.body.innerHTML.replace(/>\s+</g, '> <').trim();
    var removed = [];
    if (found.head) removed.push('the head section');
    if (found.styles) removed.push('styles');
    if (found.comments) removed.push('comments');
    if (found.settings) removed.push('tag settings such as link addresses');
    return { html: html, before: bytes(source), after: bytes(html), removed: removed };
  }
  var sizeTimer = null;
  function updateSizeNote() {
    clearTimeout(sizeTimer);
    var note = $('[data-size-note]'), value = $('#email-content').value;
    note.classList.remove('is-warning');
    var show = function (message, warning) {
      text(note, message);
      note.hidden = !message;
      note.classList.toggle('is-warning', !!warning);
    };
    if (inputKind !== 'text' || !value.trim()) return show('');
    if (inputFormat === 'html') {
      var compact = compactHtml(value.trim());
      if (compact.after > MAX_BYTES)
        return show('Even without ' + listText(compact.removed.length ? compact.removed : ['extra code']) + ', this email is ' + overKb(compact.after) + '. The reviewer takes up to 60 KB. Paste just the main part of the email, or use a screenshot.', true);
      if (!compact.removed.length) return show('');
      return show((compact.before >= 1000 ? 'We’ll send ' + kb(compact.after) + ' of your ' + kb(compact.before) + ': the' : 'We’ll send the') + ' words and the HTML tags around them. We remove ' + listText(compact.removed) + ' first. The preview keeps its look.');
    }
    var size = bytes(value.trim());
    show(size > MAX_BYTES ? 'This text is ' + overKb(size) + '. The reviewer takes up to 60 KB. Paste just the message, or use a screenshot.' : '', true);
  }
  $('#email-content').addEventListener('input', function () {
    clearTimeout(sizeTimer);
    sizeTimer = setTimeout(updateSizeNote, 250);
  });

  var fileVersion = 0;
  function loadFile(file, pasted) {
    var version = ++fileVersion;
    imageData = '';
    error('');
    $('[data-upload-preview]').hidden = true;
    text($('[data-file-name]'), '');
    if (!file) return;
    if (
      !['image/png', 'image/jpeg', 'image/webp'].includes(file.type) ||
      file.size > 4 * 1024 * 1024
    ) {
      error('Choose a PNG, JPG or WebP screenshot up to 4 MB.');
      return;
    }
    var reader = new FileReader();
    reader.onerror = function () {
      if (version === fileVersion)
        error('We couldn’t read that file. Choose it again.');
    };
    reader.onload = function () {
      if (version !== fileVersion) return;
      imageData = String(reader.result);
      $('[data-upload-preview]').src = imageData;
      $('[data-upload-preview]').hidden = false;
      text($('[data-file-name]'), (pasted ? 'Pasted screenshot' : file.name) + ' is ready to review.');
    };
    reader.readAsDataURL(file);
  }
  $('#email-image').addEventListener('change', function () {
    loadFile(this.files[0]);
    // A paste or drop can replace this file; choosing it again must still work.
    this.value = '';
  });
  var drop = $('.lab-dropzone');
  drop.addEventListener('dragover', function (e) {
    e.preventDefault();
    drop.classList.add('is-dragging');
  });
  drop.addEventListener('dragleave', function () {
    drop.classList.remove('is-dragging');
  });
  drop.addEventListener('drop', function (e) {
    e.preventDefault();
    drop.classList.remove('is-dragging');
    loadFile(e.dataTransfer.files[0]);
  });
  // Screenshots usually sit on the clipboard, not in a file. Paste one on the
  // Screenshot tab, or into the empty email box, to use it.
  document.addEventListener('paste', function (e) {
    var data = e.clipboardData;
    if (!data || $('[data-entry]').hidden) return;
    var file = Array.from(data.items || []).map(function (item) {
      return item.kind === 'file' && /^image\//.test(item.type) ? item.getAsFile() : null;
    }).find(Boolean) || Array.from(data.files || []).find(function (f) {
      return /^image\//.test(f.type);
    });
    if (!file) return;
    var typed = data.getData('text/plain');
    var target = e.target, typing = target && /^(INPUT|TEXTAREA)$/.test(target.tagName) && target.type !== 'file';
    if (inputKind === 'image' ? typing && typed : target !== $('#email-content') || typed) return;
    e.preventDefault();
    if (inputKind !== 'image') $('[data-input-tab="image"]').click();
    loadFile(file, true);
  });

  // Untrusted HTML is never inserted into the host DOM or navigated to. The
  // preview is a sandboxed document reconstructed from an inert template with
  // an allowlist. No URL-bearing attributes, remote loads, forms or scripting.
  function evidenceOptions(evidence) {
    var value = String(evidence || '').trim(), result = [], match;
    var quoted = /[“"]([^”"]{5,320})[”"]/g;
    while ((match = quoted.exec(value))) result.push(match[1]);
    var plain = value.replace(/^(?:subject(?: line)?|button|cta)\s*:\s*/i, '').replace(/^[“”"'‘’]+|[“”"'‘’]+[.!]?$/g, '').trim();
    if (plain.length >= 5 && plain.length <= 320) result.push(plain);
    return Array.from(new Set(result));
  }
  function textNodes(container) {
    var walker = document.createTreeWalker(container, window.NodeFilter.SHOW_TEXT);
    var nodes = [], node;
    while ((node = walker.nextNode()) && nodes.length < 5000) if (node.nodeValue.trim()) nodes.push(node);
    return nodes;
  }
  // Only a literal quote counts. Candidates keep their order of preference and
  // the first exact match wins. Screenshot reviews have no coordinates, so
  // they never receive invented bounding boxes.
  function locate(nodes, evidence) {
    var candidates = evidenceOptions(evidence);
    for (var i = 0; i < candidates.length; i++) {
      for (var j = 0; j < nodes.length; j++) {
        var at = nodes[j].nodeValue.toLowerCase().indexOf(candidates[i].toLowerCase());
        if (at >= 0) return { node: nodes[j], at: at, len: candidates[i].length };
      }
    }
    return null;
  }
  function wrapMatch(hit) {
    var value = hit.node.nodeValue;
    var mark = el('mark', 'lab-evidence-mark', value.slice(hit.at, hit.at + hit.len));
    mark.dataset.labEvidence = 'true';
    hit.node.replaceWith(document.createTextNode(value.slice(0, hit.at)), mark, document.createTextNode(value.slice(hit.at + hit.len)));
    return mark;
  }
  function clearMarks(container) {
    container.querySelectorAll('mark[data-lab-evidence]').forEach(function (mark) {
      mark.replaceWith(document.createTextNode(mark.textContent));
    });
    container.normalize();
  }
  function safeBodyFrom(source) {
    var template = document.createElement('template');
    template.innerHTML = source;
    var allowed = new Set([
      'DIV',
      'P',
      'SPAN',
      'B',
      'STRONG',
      'I',
      'EM',
      'U',
      'S',
      'H1',
      'H2',
      'H3',
      'H4',
      'H5',
      'H6',
      'TABLE',
      'TBODY',
      'THEAD',
      'TR',
      'TD',
      'TH',
      'BR',
      'HR',
      'UL',
      'OL',
      'LI',
      'BLOCKQUOTE',
      'CENTER',
      'A'
    ]);
    var skip = new Set([
      'SCRIPT',
      'STYLE',
      'IFRAME',
      'OBJECT',
      'EMBED',
      'LINK',
      'META',
      'BASE',
      'FORM',
      'INPUT',
      'BUTTON',
      'TEXTAREA',
      'SELECT',
      'SVG',
      'MATH',
      'TEMPLATE',
      'NOSCRIPT'
    ]);
    var holder = document.createElement('div');
    function copy(from, to, depth) {
      if (depth > 50) return;
      Array.from(from.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          to.appendChild(document.createTextNode(n.textContent));
          return;
        }
        if (n.nodeType !== 1 || skip.has(n.tagName)) return;
        if (n.tagName === 'IMG') {
          to.appendChild(
            el(
              'p',
              '',
              n.getAttribute('alt')
                ? '[Image: ' + n.getAttribute('alt') + ']'
                : '[Outside image not loaded]'
            )
          );
          return;
        }
        if (!allowed.has(n.tagName)) {
          copy(n, to, depth + 1);
          return;
        }
        var safe = document.createElement(
          n.tagName === 'A' ? 'span' : n.tagName.toLowerCase()
        );
        // Only a small visual subset; no positioning/URLs/custom properties.
        [
          'color',
          'background-color',
          'font-size',
          'font-weight',
          'text-align',
          'padding',
          'margin',
          'border',
          'border-radius',
          'line-height'
        ].forEach(function (prop) {
          var v = n.style.getPropertyValue(prop);
          if (v && !/url|var\(|expression|@|\\/i.test(v))
            safe.style.setProperty(prop, v.slice(0, 150));
        });
        if (['TD', 'TH'].includes(n.tagName))
          ['colspan', 'rowspan'].forEach(function (a) {
            var v = Number(n.getAttribute(a));
            if (v > 0 && v < 20) safe.setAttribute(a, String(v));
          });
        to.appendChild(safe);
        copy(n, safe, depth + 1);
      });
    }
    copy(template.content, holder, 0);
    return holder;
  }
  // Highlights keep a fixed dark text colour. They used to inherit it, so a
  // highlighted white button label became white on pale yellow (about 1.2:1).
  function previewDocument(holder) {
    return (
      "<!doctype html><html><head><meta charset=\"utf-8\"><meta http-equiv=\"Content-Security-Policy\" content=\"default-src 'none'; style-src 'unsafe-inline'; form-action 'none'; base-uri 'none'\"><style>body{font:16px/1.6 Arial,sans-serif;padding:20px;color:#132c41;overflow-wrap:anywhere}table{max-width:100%;width:100%}*{box-sizing:border-box;max-width:100%}h1{font-size:30px}mark[data-lab-evidence]{background:#ffe45c;color:#1b1a14;border-radius:2px;box-shadow:0 0 0 2px #ffe45c,0 0 0 4px #1b1a14;-webkit-box-decoration-break:clone;box-decoration-break:clone}</style></head><body>" +
      holder.innerHTML +
      '</body></html>'
    );
  }
  // A 1200×3682 capture was squeezed into 650px of height: 212px wide with
  // text about 4px tall. Show it at column width in a scroll box instead.
  function screenshotView(src) {
    var wrap = el('div', 'lab-shot');
    var tools = el('div', 'lab-shot-tools');
    var zoom = el('button', 'lab-shot-zoom', 'Zoom in');
    zoom.type = 'button';
    zoom.setAttribute('aria-pressed', 'false');
    tools.appendChild(zoom);
    tools.appendChild(el('span', '', 'Scroll inside the box to see all of it.'));
    var box = el('div', 'lab-shot-box');
    box.tabIndex = 0;
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', 'Your email screenshot. Scroll to see all of it.');
    var img = el('img', 'lab-reviewed-image');
    img.src = src;
    img.alt = 'The email screenshot you submitted';
    box.appendChild(img);
    // Keep the clicked point (or the middle of the box) in place.
    function setZoom(on, x, y) {
      var cx = x == null ? box.clientWidth / 2 : x, cy = y == null ? box.clientHeight / 2 : y;
      var px = (box.scrollLeft + cx) / (img.offsetWidth || 1), py = (box.scrollTop + cy) / (img.offsetHeight || 1);
      box.classList.toggle('is-zoomed', on);
      zoom.setAttribute('aria-pressed', String(on));
      text(zoom, on ? 'Zoom out' : 'Zoom in');
      box.scrollLeft = px * img.offsetWidth - cx;
      box.scrollTop = py * img.offsetHeight - cy;
    }
    zoom.addEventListener('click', function () {
      setZoom(!box.classList.contains('is-zoomed'));
    });
    img.addEventListener('click', function (e) {
      var r = box.getBoundingClientRect();
      setZoom(!box.classList.contains('is-zoomed'), e.clientX - r.left, e.clientY - r.top);
    });
    wrap.appendChild(tools);
    wrap.appendChild(box);
    return wrap;
  }
  function renderOriginal(input) {
    var target = $('[data-original]');
    target.replaceChildren();
    text($('[data-original-title]'), activeRole === 'rewrite' ? 'The new version' : activeSample ? 'Example email' : 'Your email');
    text(
      $('[data-input-kind]'),
      input.kind === 'image'
        ? 'Screenshot'
        : input.format === 'html' ? 'HTML preview · outside images off' : 'Plain text'
    );
    if (input.subject) {
      var subject = el('div', 'lab-original-subject');
      subject.appendChild(el('span', '', 'Subject line'));
      subject.appendChild(el('strong', '', input.subject));
      target.appendChild(subject);
    }
    if (input.kind === 'image') {
      target.appendChild(screenshotView(input.content));
      return;
    }
    if (input.format === 'html') {
      var frame = el('iframe', 'lab-email-frame');
      frame.title = 'Email preview with outside images and links turned off';
      frame.setAttribute('sandbox', '');
      frame.referrerPolicy = 'no-referrer';
      frame.srcdoc = previewDocument(safeBody);
      target.appendChild(frame);
      target.appendChild(
        el(
          'small',
          'lab-preview-note',
          'This preview does not open links or load outside images. It may look different from your email.'
        )
      );
    } else target.appendChild(el('pre', 'lab-plain-email', input.content));
  }
  // Match every tip against the subject, then the email, once. The match
  // drives both the excerpt inside the tip and the highlight in the email.
  function prepareFindings(report, input) {
    // The preview keeps the pasted HTML's look; only the request is compacted.
    safeBody = input.kind === 'text' && input.format === 'html' ? safeBodyFrom(input.source || input.content) : null;
    var items = [];
    if (input.subject) items.push({ nodeValue: input.subject, where: 'subject' });
    if (safeBody) textNodes(safeBody).forEach(function (node) { items.push({ nodeValue: node.nodeValue, where: 'body' }); });
    else if (input.kind === 'text') items.push({ nodeValue: input.content, where: 'body' });
    return report.findings.map(function (finding, index) {
      var hit = locate(items, finding.evidence);
      return {
        finding: finding,
        sourceIndex: index,
        match: hit ? { where: hit.node.where, text: hit.node.nodeValue, at: hit.at, len: hit.len, html: !!safeBody } : null
      };
    }).sort(function (a, b) {
      return priority[a.finding.grade] - priority[b.finding.grade] || a.sourceIndex - b.sourceIndex;
    });
  }
  // The line around a match, trimmed to about 90 characters either side. In
  // HTML a text node already ends at its tags; its newlines are only source
  // formatting, so the whole node counts as the line.
  function excerpt(match) {
    var value = match.text, at = match.at, end = at + match.len;
    var lineStart = match.html ? 0 : value.lastIndexOf('\n', at - 1) + 1, lineEnd = match.html ? -1 : value.indexOf('\n', end);
    if (lineEnd < 0) lineEnd = value.length;
    var from = Math.max(lineStart, at - 90), to = Math.min(lineEnd, end + 90);
    if (from > lineStart) {
      var space = value.indexOf(' ', from);
      if (space > -1 && space < at) from = space + 1;
    }
    if (to < lineEnd) {
      var back = value.lastIndexOf(' ', to);
      if (back > end) to = back;
    }
    var squash = function (s) { return s.replace(/\s+/g, ' '); };
    return {
      before: (from > lineStart ? '…' : '') + squash(value.slice(from, at)).replace(/^ /, ''),
      match: squash(value.slice(at, end)),
      after: squash(value.slice(end, to)).replace(/ $/, '') + (to < lineEnd ? '…' : '')
    };
  }
  // On a phone the email sits below every tip. Each tip now carries the
  // matching words from the email, so no one has to scroll back and forth.
  function evidenceBlock(entry) {
    var f = entry.finding, m = entry.match;
    if (m) {
      var figure = el('figure', 'lab-excerpt');
      figure.appendChild(el('figcaption', '', m.where === 'subject' ? 'In the subject line' : activeSample ? 'In the email' : 'In your email'));
      var parts = excerpt(m), line = el('p');
      line.append(parts.before, el('mark', 'lab-excerpt-mark', parts.match), parts.after);
      figure.appendChild(line);
      return figure;
    }
    var quote = el('div', 'lab-quote');
    quote.appendChild(el('blockquote', '', f.evidence));
    if (lastInput.kind !== 'image')
      quote.appendChild(el('p', 'lab-quote-note', 'No exact text match was found in your email. Check this quote yourself.'));
    return quote;
  }
  function renderFindings() {
    var list = $('[data-findings]');
    list.replaceChildren();
    orderedFindings.forEach(function (entry, i) {
      var f = entry.finding, grade = grades[f.grade];
      var card = el('article', 'lab-finding lab-finding-' + grade[0]);
      card.dataset.finding = String(i);
      var head = el('div', 'lab-finding-head');
      head.appendChild(el('span', 'lab-chip lab-chip-' + grade[0], grade[1]));
      head.appendChild(el('h3', '', f.title));
      card.appendChild(head);
      card.appendChild(evidenceBlock(entry));
      card.appendChild(el('p', 'lab-finding-why', f.explanation));
      var fix = el('div', 'lab-specific-fix');
      fix.appendChild(el('strong', '', grade[0] === 'keep' ? 'Keep this' : 'What to change'));
      fix.appendChild(el('p', '', f.fix));
      card.appendChild(fix);
      if (entry.match) {
        var show = el('button', 'lab-show-evidence', 'Show in the email');
        show.type = 'button';
        show.dataset.showEvidence = String(i);
        show.setAttribute('aria-pressed', 'false');
        show.addEventListener('click', function () {
          showEvidence(i, true);
        });
        card.appendChild(show);
      }
      list.appendChild(card);
    });
    var changes = orderedFindings.filter(function (entry) {
      return grades[entry.finding.grade][0] !== 'keep';
    }).length;
    text($('[data-tip-count]'), orderedFindings.length + ' tips' + (changes ? ', changes first' : ''));
  }
  // One highlight at a time, placed from the tip's own evidence. The old
  // example outlined elements from a fixed tip-number map instead.
  function showEvidence(i, follow) {
    var entry = orderedFindings[i];
    if (!entry || !entry.match) return;
    $$('[data-show-evidence]').forEach(function (button) {
      var on = Number(button.dataset.showEvidence) === i;
      button.setAttribute('aria-pressed', String(on));
      text(button, on ? 'Highlighted in the email' : 'Show in the email');
    });
    $$('[data-finding]').forEach(function (card) {
      card.classList.toggle('is-shown', Number(card.dataset.finding) === i);
    });
    text($('[data-see-tip]'), 'Back to tip ' + (i + 1) + ' ↑');
    var target = $('[data-original]'), evidence = entry.finding.evidence;
    var frame = target.querySelector('iframe');
    clearMarks(target);
    if (entry.match.where === 'subject') {
      var subject = target.querySelector('.lab-original-subject strong');
      var hit = subject && locate(textNodes(subject), evidence);
      if (hit) wrapMatch(hit);
      if (frame) frame.srcdoc = previewDocument(safeBody);
    } else if (frame) {
      var copy = safeBody.cloneNode(true), bodyHit = locate(textNodes(copy), evidence);
      if (bodyHit) wrapMatch(bodyHit);
      frame.srcdoc = previewDocument(copy);
    } else {
      var plain = target.querySelector('.lab-plain-email');
      var plainHit = plain && locate(textNodes(plain), evidence);
      if (plainHit) {
        var mark = wrapMatch(plainHit);
        plain.scrollTop = Math.max(0, mark.offsetTop - plain.clientHeight / 3);
      }
    }
    text(
      $('[data-evidence-note]'),
      entry.match.where === 'subject'
        ? 'Tip ' + (i + 1) + ' is about the subject line, highlighted above the email.'
        : 'Tip ' + (i + 1) + '’s words are highlighted in yellow.' + (frame ? ' If you can’t see them, scroll inside the preview.' : '')
    );
    if (!follow) return;
    // Side by side, the email stays in view beside the tips. Stacked on a
    // phone, it is below them, so take the visitor there.
    var original = $('.lab-original');
    if (original.getBoundingClientRect().top >= $('.lab-coach').getBoundingClientRect().bottom - 1) focusSection(original);
  }
  if ($('[data-see-tip]')) $('[data-see-tip]').addEventListener('click', function () {
    focusSection($('[data-finding].is-shown') || $('.lab-coach'));
  });
  function validReport(report) {
    return (
      report &&
      Number.isInteger(report.score) &&
      report.score >= 0 &&
      report.score <= 100 &&
      report.categories &&
      report.categories.length === 5 &&
      report.categories.every(function (c, i) {
        return (
          c.id === Object.keys(labels)[i] &&
          (c.score === null ||
            (Number.isInteger(c.score) && c.score >= 0 && c.score <= 20))
        );
      }) &&
      Array.isArray(report.findings) &&
      report.findings.length >= 3 &&
      report.findings.length <= 6 &&
      report.findings.every(function (f) {
        return grades[f.grade] && typeof f.evidence === 'string';
      }) &&
      report.rewrite &&
      Array.isArray(report.rewrite.body) &&
      Array.isArray(report.limitations)
    );
  }
  function reviewContext(report, input, sample) {
    var parts = [(sample ? 'Example goal: ' : 'Goal: ') + goals[input.goal] + '.'];
    parts.push(input.audience
      ? 'Reader: ' + input.audience.replace(/[.\s]+$/, '') + '.'
      : 'No reader details, so Fit for the reader is judged from the email and its goal alone.');
    var design = report.categories.find(function (c) { return c.id === 'design'; });
    if (input.kind === 'image')
      parts.push(design && design.score !== null ? 'Words and the visible layout were reviewed.' : 'Words reviewed. Look and layout was not scored; see how the score adds up.');
    else if (activeRole === 'rewrite') parts.push('The new version was reviewed as plain text, so Look and layout needs a screenshot.');
    else if (input.format === 'html') parts.push('Words and HTML reviewed' + (input.trimmed ? ' (' + input.trimmed + ')' : '') + '. Look and layout needs a screenshot.');
    else parts.push('Words reviewed. Look and layout needs a screenshot.');
    return parts.join(' ');
  }
  // Compare on the same parts. A screenshot review scores Look and layout, but
  // the plain-text new version can't be, and 5 parts against 4 isn't fair.
  function sharedScore(report, other) {
    return rubricScore(report.categories.map(function (c, i) {
      return other.categories[i].score === null ? { score: null } : c;
    }));
  }
  function renderCompare() {
    var bar = $('[data-compare]');
    bar.replaceChildren();
    bar.hidden = activeSample || reviews.length < 2;
    if (bar.hidden) return;
    var a = reviews[0].report, b = reviews[1].report;
    [['Your email', sharedScore(a, b)], ['New version', sharedScore(b, a)]].forEach(function (item, index) {
      var button = el('button', 'lab-compare-option');
      button.type = 'button';
      button.setAttribute('aria-pressed', String(reviews[index].report === activeReport));
      button.appendChild(el('span', '', item[0]));
      button.appendChild(el('strong', '', item[1] + ' / 100'));
      button.addEventListener('click', function () {
        if (reviews[index].report === activeReport) return;
        showReport(reviews[index].report, reviews[index].input, false, index ? 'rewrite' : 'original', true);
        var pressed = $('[data-compare] [aria-pressed="true"]');
        if (pressed) pressed.focus();
      });
      bar.appendChild(button);
    });
    var left = a.categories.filter(function (c, i) {
      return (c.score === null) !== (b.categories[i].score === null);
    }).map(function (c) { return labels[c.id]; });
    if (left.length) bar.appendChild(el('p', 'lab-compare-note', 'Both scores leave out ' + listText(left) + ', so they compare the same parts.'));
  }
  function renderCategories(report) {
    var list = $('[data-categories]'), summary = [];
    list.replaceChildren();
    report.categories.forEach(function (c) {
      var card = el('div', 'lab-grade');
      card.appendChild(el('span', 'lab-grade-name', labels[c.id]));
      card.appendChild(el('strong', '', c.score === null ? 'Not scored' : c.score + ' / 20'));
      card.appendChild(el('small', 'lab-grade-label', c.score === null ? (c.id === 'design' ? 'Needs a screenshot' : 'Not enough to go on') : band(c.score, c.id)));
      var bar = el('div', 'lab-grade-bar');
      var fill = el('i');
      fill.style.width = (c.score === null ? 0 : c.score * 5) + '%';
      bar.appendChild(fill);
      card.appendChild(bar);
      // Shown, not folded away: the reason is where lost points are explained.
      card.appendChild(el('p', 'lab-grade-reason', c.reason));
      list.appendChild(card);
      summary.push(labels[c.id] + ' ' + (c.score === null ? 'not scored' : c.score));
    });
    text($('[data-breakdown-summary]'), summary.join(' · '));
  }
  // The server's first line assumes reader details were given.
  function limitationLines(report, input) {
    return report.limitations.map(function (line) {
      return input.audience ? line : line.replace('using your goal and the readers you described', 'using your goal. You didn’t describe the readers, so fit is judged from the email and its goal');
    });
  }

  function showReport(report, input, sample, role, switching) {
    var followReview = sample || watchingReview();
    activeReport = report;
    lastInput = input;
    activeSample = sample;
    activeRole = role || 'original';
    orderedFindings = prepareFindings(report, input);
    root.dataset.reviewLoading = 'false';
    $('[data-review-loading]').hidden = true;
    $('[data-entry]').hidden = true;
    workflow('review');
    $('[data-results]').hidden = false;
    $('[data-results]').dataset.sample = String(sample);
    text($('[data-review-kind]'), sample ? 'EXAMPLE REVIEW' : activeRole === 'rewrite' ? 'REVIEW OF THE NEW VERSION' : 'YOUR EMAIL REVIEW');
    // The disclosure sits inside the score header. As a strip above it, it
    // scrolled under the sticky site header while the panel said "YOUR REVIEW".
    $('[data-result-notice]').hidden = !sample;
    text($('[data-result-notice]'), sample ? 'Written in advance to show what a review of pasted HTML looks like. You haven’t sent us anything, and it didn’t use a free review.' : '');
    text($('[data-coach-kind]'), sample ? 'EXAMPLE REVIEW' : activeRole === 'rewrite' ? 'REVIEW OF THE NEW VERSION' : 'YOUR REVIEW');
    text($('[data-new-review]'), sample ? 'Review my email →' : 'Review another email →');
    // Lead with what the score means. A bare "76/100" read as more precise
    // than an AI review is: the same email can score differently next time.
    text($('[data-score-description]'), band(report.score / 5, 'overall'));
    text($('[data-score]'), report.score);
    text($('[data-verdict]'), report.verdict);
    text($('[data-summary]'), report.summary);
    text($('[data-review-context]'), reviewContext(report, input, sample));
    renderCompare();
    renderCategories(report);
    renderFindings();
    var limits = $('[data-limitations]');
    limits.replaceChildren();
    limitationLines(report, input).forEach(function (line) {
      limits.appendChild(el('li', '', line));
    });
    renderOriginal(input);
    text(
      $('[data-evidence-note]'),
      input.kind === 'image'
        ? 'Screenshot reviews can’t point to exact spots. Use each tip’s quote to find it in your screenshot.'
        : 'None of the tips quote words we could find in this email.'
    );
    text($('[data-see-tip]'), 'Back to the tips ↑');
    var first = orderedFindings.findIndex(function (entry) { return entry.match; });
    if (first > -1) showEvidence(first, false);
    renderRewrite();
    text($('[data-copy-status]'), '');
    var back = $('[data-back-to-review]');
    if (back) {
      back.hidden = false;
      text(back.querySelector('a'), sample ? 'Back to the example review ↑' : 'Back to your email review ↑');
    }
    $('.lab-category-breakdown').open = false;
    // A finished request must not pull someone back from another part of the page.
    if (followReview) focusSection($('.lab-score-header'), sample);
    // Switching between the two reviews to compare them is not a new review.
    if (!switching) track('email_review_completed', { mode: sample ? 'sample' : input.kind });
  }
  $$('[data-sample-review]').forEach(function (button) {
    button.addEventListener('click', function () {
      clearRequest();
      pendingMode = 'form';
      error('');
      setGoalInvalid(false);
      reviews = [];
      showReport(sampleReport, sampleInput, true, 'original');
    });
  });

  var limitMessage = 'No free reviews are left for today. You may have used your 5, or the tool may have reached its daily limit for everyone. Please try again tomorrow. The example review still works.';
  var unavailableMessage = 'The AI reviewer is unavailable right now. Your email is still here. Please try again later, or open the example review.';
  async function runReview(input, mode) {
    clearRequest();
    error('');
    rewriteError('');
    pendingMode = mode || 'form';
    var version = requestVersion;
    request = new AbortController();
    var controller = request;
    var reviewing = pendingMode === 'rewrite' ? 'the new version' : 'your email';
    startLoading();
    text($('[data-loading-title]'), pendingMode === 'rewrite' ? 'Let’s look at the new version.' : 'Let’s look at your email.');
    text(
      $('[data-loading-copy]'),
      'Reading ' + reviewing + ' and what you want it to do. This may take about a minute.'
    );
    // There is no facts field, so don't claim to check "the facts you shared".
    var messages = [
      'Checking the words, the next step and any claims in the email…',
      'Still reviewing. Your score and tips will appear when we finish.'
    ];
    var phase = 0;
    loadingTimer = setInterval(function () {
      text(
        $('[data-loading-copy]'),
        messages[Math.min(phase++, messages.length - 1)]
      );
    }, 12000);
    var timeout = setTimeout(function () {
      controller.abort();
    }, 75000);
    try {
      var response;
      try {
        response = await fetch('/api/email-lab/review', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ kind: input.kind, content: input.content, subject: input.subject, goal: input.goal, audience: input.audience }),
          signal: controller.signal,
          credentials: 'omit'
        });
      } catch (e) {
        if (e.name === 'AbortError') throw e;
        // The browser's "Failed to fetch" meant nothing to a merchant.
        throw new Error('We couldn’t reach the reviewer. Check your internet connection and try again. Your email is still here.');
      }
      var contentType = response.headers.get('content-type') || '';
      // The same 429 covers this visitor's 5 a day and the tool's limit for
      // everyone, so the message must not blame the visitor.
      if (response.status === 429) throw new Error(limitMessage);
      // Any non-JSON answer used to say "not available in this preview", even
      // on the live site.
      if (response.status === 503 || !contentType.includes('application/json'))
        throw new Error(unavailableMessage);
      var result = await response.json();
      if (!response.ok)
        throw new Error(
          result.error || 'The review couldn’t finish. Please try again.'
        );
      if (!validReport(result))
        throw new Error('The review came back incomplete. Please try again.');
      if (version !== requestVersion) return;
      if (pendingMode === 'rewrite') reviews = [reviews[0], { report: result, input: input }];
      else reviews = [{ report: result, input: input }];
      showReport(result, input, false, pendingMode === 'rewrite' ? 'rewrite' : 'original');
    } catch (e) {
      if (version !== requestVersion) return;
      var followError = watchingReview();
      var message = e.name === 'AbortError'
        ? 'The review took too long, so we stopped it. Your email is still here. Please try again. A stopped review still counts toward today’s 5.'
        : e.message;
      var fromRewrite = pendingMode === 'rewrite' && !!activeReport;
      endLoading();
      if (fromRewrite) {
        rewriteError(message);
        if (followError) focusSection($('[data-rewrite-error]'));
      } else {
        error(message);
        if (followError) focusSection($('[data-review-error]'), false);
      }
    } finally {
      clearTimeout(timeout);
      if (version === requestVersion) {
        clearInterval(loadingTimer);
        loadingTimer = null;
        request = null;
      }
    }
  }
  $('[data-review-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var raw =
      inputKind === 'image' ? imageData : $('#email-content').value.trim();
    if (!raw || (inputKind === 'text' && bytes(raw) < 40)) {
      error(
        inputKind === 'image'
          ? 'Choose a screenshot first.'
          : 'Paste more of your email, including the main button or link text.'
      );
      return;
    }
    var goal = selectedGoal();
    if (!goals[goal]) {
      error('Choose what this email is for so we can review it against the right goal.');
      setGoalInvalid(true);
      focusGoal();
      return;
    }
    var subject = $('#email-subject').value.trim(), audience = $('#email-audience').value.trim();
    var content = raw, trimmed = '';
    if (inputKind === 'text' && inputFormat === 'html') {
      var compact = compactHtml(raw);
      content = compact.html;
      if (compact.removed.length) trimmed = sentNote(compact);
      if (bytes(content) > MAX_BYTES) {
        error('Even without ' + listText(compact.removed.length ? compact.removed : ['extra code']) + ', this email is ' + overKb(compact.after) + '. The reviewer takes up to 60 KB. Paste just the main part of the email, or use a screenshot.');
        return;
      }
      if (bytes(content) < 40) {
        error('We couldn’t find enough words in that code. Paste the whole email’s HTML, or use a screenshot.');
        return;
      }
    }
    // Match the API's UTF-8 limits before making a request. Browser maxlength
    // counts UTF-16 units, so it alone cannot catch long non-ASCII input.
    if (bytes(subject) > 180 || bytes(audience) > 280 || (inputKind === 'text' && bytes(content) > MAX_BYTES)) {
      error(bytes(subject) > 180 ? 'That subject line is too long for this reviewer. Shorten it and try again.' : bytes(audience) > 280 ? 'Keep the reader details to a short sentence.' : 'This email is too long for the reviewer: it is ' + overKb(bytes(content)) + ' and the limit is 60 KB. Paste just the message, or add a screenshot.');
      return;
    }
    track('email_review_started', { mode: inputKind });
    runReview({
      kind: inputKind,
      format: inputFormat,
      content: content,
      source: raw,
      subject: subject,
      goal: goal,
      audience: audience,
      trimmed: trimmed
    }, 'form');
  });
  goalInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      setGoalInvalid(false);
      error('');
    });
    input.addEventListener('invalid', function (event) {
      // Native required validation happens before submit; show the same
      // inline message and focus as the submit guard, without a browser popup.
      event.preventDefault();
      setGoalInvalid(true);
      error('Choose what this email is for so we can review it against the right goal.');
      focusGoal();
    });
  });
  $('[data-review-form]').addEventListener('reset', function () {
    setGoalInvalid(false);
    error('');
    setTimeout(updateSizeNote);
  });
  $('[data-cancel-review]').addEventListener('click', function () {
    var fromRewrite = pendingMode === 'rewrite' && !!activeReport;
    clearRequest();
    endLoading();
    pendingMode = 'form';
    focusSection(fromRewrite ? $('[data-rewrite]') : $('[data-review-form]'));
  });
  $('[data-new-review]').addEventListener('click', function () {
    clearRequest();
    pendingMode = 'form';
    activeReport = null;
    lastInput = null;
    activeSample = false;
    orderedFindings = [];
    reviews = [];
    endLoading();
    error('');
    setGoalInvalid(false);
    if ($('[data-back-to-review]')) $('[data-back-to-review]').hidden = true;
    focusSection($('[data-review-form]'));
  });
  function draftText(d) {
    return (
      'Subject: ' +
      d.subject +
      '\nInbox preview: ' +
      d.preview +
      '\n\n' +
      d.headline +
      '\n\n' +
      d.body.join('\n\n') +
      '\n\nButton: ' +
      d.cta +
      '\n[Add the link you want this button to open]'
    );
  }
  // Pasting one blob mixed "Subject:" and the preview into the email body.
  // Each part goes into its own field in an email app, so each copies alone.
  function draftField(d, field) {
    return field === 'body' ? d.headline + '\n\n' + d.body.join('\n\n') : d[field];
  }
  // A re-review used to send the copy/download text: labels, "[Add the link…]"
  // and [placeholders] included, so the AI reviewed our notes as email copy.
  function cleanLine(value) {
    return String(value || '')
      .replace(/\[[^\]]*\]/g, ' ')
      .replace(/\(\s*\)/g, ' ')
      .replace(/\s+([.,;:!?])/g, '$1')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }
  function cleanDraft(d) {
    return {
      subject: cleanLine(d.subject),
      content: [d.preview, d.headline].concat(d.body, [d.cta]).map(cleanLine).filter(function (line) {
        return /\w|[^\x00-\x7f]/.test(line);
      }).join('\n\n')
    };
  }
  function renderRewrite() {
    var d = activeReport.rewrite;
    text($('[data-rewrite-kind]'), activeSample ? 'EXAMPLE NEW VERSION' : activeRole === 'rewrite' ? 'ANOTHER SUGGESTED VERSION' : 'YOUR NEW VERSION');
    text($('[data-draft-subject]'), d.subject);
    text($('[data-draft-preview]'), d.preview);
    text($('[data-draft-headline]'), d.headline);
    text($('[data-draft-cta]'), d.cta);
    text($('[data-rewrite-rationale]'), d.rationale);
    var body = $('[data-draft-body]');
    body.replaceChildren();
    d.body.forEach(function (p) {
      body.appendChild(el('p', '', p));
    });
    // Never on the example: it would spend a free review on a made-up email.
    $('[data-rereview]').hidden = activeSample || activeRole !== 'original' || reviews.length !== 1;
    rewriteError('');
    $('[data-rewrite]').hidden = false;
  }
  $('[data-show-rewrite]').addEventListener('click', function () {
    workflow('draft');
    focusSection($('[data-rewrite]'));
    track('email_rewrite_opened');
  });
  async function copyText(value, done) {
    try {
      await navigator.clipboard.writeText(value);
      text($('[data-copy-status]'), done);
      track('email_draft_copied');
    } catch (e) {
      text(
        $('[data-copy-status]'),
        'We couldn’t copy that. Select the text and copy it, or use “↓ Download review + draft” below to keep it.'
      );
    }
  }
  $('[data-copy-draft]').addEventListener('click', function () {
    copyText(draftText(activeReport.rewrite), 'Copied the whole draft. Fill in anything in [brackets], add your link and check the details before sending.');
  });
  var copiedWords = {
    subject: 'Subject copied.',
    preview: 'Preview line copied.',
    body: 'Email text copied. Fill in anything in [brackets] before sending.',
    cta: 'Button words copied. Add the link in your email app.'
  };
  $$('[data-copy-field]').forEach(function (button) {
    button.addEventListener('click', function () {
      var field = button.dataset.copyField;
      copyText(draftField(activeReport.rewrite, field), copiedWords[field]);
    });
  });
  $('[data-review-rewrite]').addEventListener('click', function () {
    // The visitor's form is never touched: this used to overwrite their
    // pasted email, subject, goal and reader with the draft.
    if (activeSample || reviews.length !== 1) return;
    var original = reviews[0];
    var clean = cleanDraft(original.report.rewrite);
    if (bytes(clean.content) < 40 || !clean.subject) {
      rewriteError('This new version is too short to review on its own. Copy it into your email first, then review the whole email.');
      return;
    }
    track('email_rewrite_reviewed');
    runReview({
      kind: 'text',
      format: 'text',
      content: clean.content,
      subject: clean.subject.slice(0, 180),
      goal: original.input.goal,
      audience: original.input.audience
    }, 'rewrite');
  });
  $('[data-download-review]').addEventListener('click', function () {
    var r = activeReport;
    var body =
      (activeSample
        ? 'myuser.ai EXAMPLE EMAIL REVIEW\nWritten in advance to show how the tool works. It is not a new AI review.\n'
        : 'myuser.ai EMAIL REVIEW\n') +
      band(r.score / 5, 'overall') +
      ' · ' +
      r.score +
      '/100 — rates the email, not its future sales\n' +
      r.verdict +
      '\n' +
      r.summary +
      '\n' +
      reviewContext(r, lastInput, activeSample) +
      '\n\nHOW THE SCORE ADDS UP\n' +
      r.categories
        .map(function (c) {
          return (
            labels[c.id] +
            ': ' +
            (c.score === null ? 'Not scored' : c.score + '/20 · ' + band(c.score, c.id)) +
            '\n' +
            c.reason
          );
        })
        .join('\n\n') +
      '\n\nTIPS\n' +
      orderedFindings
        .map(function (entry) {
          var f = entry.finding;
          return (
            grades[f.grade][1] +
            ': ' +
            f.title +
            '\n' +
            (entry.match ? 'Quoted from the email: ' : 'Quote: ') +
            f.evidence +
            '\n' +
            f.explanation +
            '\nWhat to do: ' +
            f.fix
          );
        })
        .join('\n\n') +
      '\n\nSUGGESTED NEW VERSION\n' +
      draftText(r.rewrite) +
      '\n\nWHAT THIS REVIEW CANNOT CHECK\n' +
      limitationLines(r, lastInput).join('\n');
    var url = URL.createObjectURL(
      new Blob([body], { type: 'text/plain;charset=utf-8' })
    );
    var a = el('a');
    a.href = url;
    a.download = 'myuser-email-review.txt';
    a.click();
    setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 1000);
    track('email_review_downloaded');
  });

  // "Details" used to land on a closed answer. Open it on the way there.
  function openDetails(hash) {
    var id = String(hash || '').replace(/^#/, '');
    var target = id && document.getElementById(id);
    if (target && target.tagName === 'DETAILS' && root.contains(target)) target.open = true;
  }
  root.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href^="#"]');
    if (link) openDetails(link.getAttribute('href'));
  });
  openDetails(location.hash);
  window.addEventListener('pagehide', function () {
    clearRequest();
  });
})();
